const ModalContainer =
{
    "ContainerPk": "",
    "ContainerOrderFK": "",
    "ContainerNumber": "",
    "ContainerplanningFK": "",
    "ContainerType": { Code: "", Description: "" },
    "ContainerWeight": "",
    "ContainerWeightUnit": { Unit: "", Description: "" }
}



export default ModalContainer